var _jsxFileName = "/opt/atlassian/pipelines/agent/build/src/components/utility/Main/index.tsx";
import React, { useEffect, useRef } from 'react';
import { VStack } from '@adc/parallax-component-library';
import { MAIN_SIZE } from 'Reducers/scrollPage/types';
import { store } from 'Utilities/store';
const Main = ({
  px,
  ...rest
}) => {
  const mainRef = useRef(null);
  useEffect(() => {
    if (store && mainRef.current) {
      store.dispatch({
        type: MAIN_SIZE,
        mainSize: mainRef.current.clientHeight
      });
    }
  }, [mainRef]);
  return /*#__PURE__*/React.createElement(VStack, Object.assign({
    ref: mainRef,
    paddingHorizontal: px,
    background: "$surface.background",
    style: [{
      minHeight: window.innerHeight,
      height: '100vh'
    }]
  }, rest, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 24,
      columnNumber: 5
    }
  }));
};
export { Main };